import axios from "axios"
import CONSTANTS from "../CONSTANTS"
import CONF_API from "../CONF_API"
import common from "../methods/common"


const attendenceModals = {
    getAttendenceByEmpId1(empId) {
        const API_URL = CONSTANTS.API_URL + CONF_API.ATTENDENCE_BY_EMPLOYEE_ID
        return new Promise((resolve, reject) => {
            axios.post(`${API_URL}`, { employee_id: empId }).then((response) => {
                if (response.data) {
                    resolve(response.data)
                } else reject("No Report Found, Some Error Occured")
            }).catch((err) => {
                reject(err)
            })
        })
    },
    async markAttendence(obj) {
        const API_URL = CONSTANTS.API_URL + CONF_API.MARK_ATTENDENCE;

        try {
            let u = JSON.parse(localStorage.getItem('user'));
            console.log(u)
            let payload = {
                "date": common.getTodayDate(),
                "employee_id": u.employee_id,
                "status":obj.status,
                "comment": "",
                "update_history": [
                    ""
                ]
            }
            const response = await axios.post(API_URL, payload);
            if (response.data) {
                return response.data;
            } else {
                throw new Error("Some error occured!!,Please try again in some time");
            }
        } catch (err) {
            throw err;
        }
    },
    async editAttendence(obj) {
        const API_URL = CONSTANTS.API_URL + CONF_API.EDIT_ATTENDENCE;

        try {
            let u = JSON.parse(localStorage.getItem('user'));
            console.log(u)
            let payload = {
                ...obj,
                // "date": common.getTodayDate(),
                "employee_id": u.employee_id,
                // "status":obj.status,
                // "comment": "",
                // "update_history": [
                //     ""
                // ]
            }
            const response = await axios.post(API_URL, payload);
            if (response.data) {
                return response.data;
            } else {
                throw new Error("Some error occured!!,Please try again in some time");
            }
        } catch (err) {
            throw err;
        }
    },
    async getAttendenceByEmpId(empId="") {

        const API_URL = CONSTANTS.API_URL + CONF_API.ATTENDENCE_BY_EMPLOYEE_ID;
        let u = JSON.parse(localStorage.getItem('user'));
        try {
            const response = await axios.post(API_URL, { employee_id: u.employee_id });
            if (response.data) {
                return response.data;
            } else {
                throw new Error("No Report Found, Some Error Occurred");
            }
        } catch (err) {
            throw err;
        }

    }
}


export default attendenceModals